module.exports = __webpack_public_path__ + "static/anti-burglary-1453e5c14b46044e52e9b5d973466bf0.svg";